/** @module EngineeringChange/ImpactedItemsMatrix */
define([
	"dojo/_base/declare",
	"csi/table/matrix/Path"
], function(declare,Path) {

	return declare(Path, {
		sortAttr: "ImpactLevel"
	});
});
